import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, inject, input, model, output, signal } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';

export interface MessageData {
    subject: string;
    message: string;
    type: string;
    dateTime?: string;
    project?: string;
    service?: string;
}

@Component({
    selector: 'app-message-dialog',
    standalone: true,
    imports: [
        CommonModule,
        DialogModule,
        ButtonModule,
        CardModule,
        DividerModule,
        TooltipModule,
        BadgeModule
    ],
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent {

    readonly visible = model<boolean>(false);
    readonly messageData = model<MessageData | null>(null);

    // Output signals
    readonly visibleChange = output<boolean>();
    readonly copyToClipboard = output<string>();

    private clipboard = inject(Clipboard);

    constructor() { }

    public hide(): void {
        this.visible.set(false);
        this.visibleChange.emit(false);
    }

    public copyMessage(): void {
        const data = this.messageData();
        if (data?.message) {
            this.clipboard.copy(data.message);
            this.copyToClipboard.emit(data.message);
        }
    }

    public copySubject(): void {
        const data = this.messageData();
        if (data?.subject) {
            this.clipboard.copy(data.subject);
            this.copyToClipboard.emit(data.subject);
        }
    }

    public getTypeSeverity(type: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined {
        switch (type?.toLowerCase()) {
            case 'error':
                return 'danger';
            case 'warning':
                return 'warn';
            case 'info':
                return 'info';
            case 'success':
                return 'success';
            default:
                return 'secondary';
        }
    }
}